import React from "react";
import injectStores from "../RootStore/injectStores";
import ViewStore from "stores/ViewStore";
import { computed } from "mobx";

interface CardBodyProps {
  children?: React.ReactNode;
  viewStore?: ViewStore;
  viewportCard?: boolean;
  cardHeight?: number;
  grayBackground?: boolean;
}

const CardBody = injectStores(
  ({
    viewStore,
    children,
    viewportCard = false,
    cardHeight,
    grayBackground = false,
    ...rest
  }: CardBodyProps) => {
    if (!viewStore) return null;
    const { isMobile, cardBodySize } = viewStore;
    const getCardBodyHeight = computed(() => {
      if (viewportCard) {
        return cardBodySize.height;
      }
      return cardHeight;
    }).get();

    return (
      <div
        id="CardBody"
        style={{
          height: getCardBodyHeight,
          overflow: "auto",
          padding: isMobile ? "4px" : "10px 8px",
          backgroundColor: grayBackground ? "transparent" : "white",
          borderRadius: "8px",
        }}
        {...rest}
      >
        {children}
      </div>
    );
  }
);

export default CardBody;
